// YYYYMMDDを日付形式YYYY-MM-DDに
export function ymdToText(ymd) {
    let text = ''+ymd;
    return text.substr(0,4)+'-'+text.substr(4,2)+'-'+text.substr(6,2);
}
export function ymdToDate(ymd) {
    let dt = new Date(ymdToText(ymd));
    return dt;
}
export function dateToText(dt) {
    return ('0000'+dt.getFullYear()).slice(-4)+'-'+('00'+(dt.getMonth()+1)).slice(-2)+'-'+('00'+dt.getDate()).slice(-2);
}
export function dateToVal(dt) {
    return (dt.getFullYear()*10000+(dt.getMonth()+1)*100+dt.getDate()*1)*10000+(dt.getHours()*100+dt.getMinutes()*1);
}
export function addFigure(val) {
    return Number(val).toLocaleString();
}